import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";

import { environment } from "../environments/environment";
import { AuthenticationService } from "./core/_services/authentication.service";
import { DocumentActions } from "./core/store/document";
import { loaderSelector } from "./core/store/loader";
import { AppState } from "./core/store/store";
import { TelemetryActions } from "./core/store/telemetry";
import { UserActions } from "./core/store/user";
import { GlobalLoaderComponent } from "./shared/elements/global-loader/global-loader.component";
import { HeaderComponent } from "./shared/layout/header/header.component";
import { SideNavComponent } from "./shared/layout/side-nav/side-nav.component";

const imports = [
  HeaderComponent,
  SideNavComponent,
  GlobalLoaderComponent,
  CommonModule,
  RouterModule,
];

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private store = inject<Store<AppState>>(Store);

  title = "du-portal";
  loading$ = this.store.select(loaderSelector);
  authService = inject(AuthenticationService);
  isAuthenticated = this.authService.isAuthenticated();

  ngOnInit() {
    if (this.isAuthenticated) {
      this.store.dispatch(UserActions.loadUsers());
      if (environment.environmentName !== "local") {
        this.store.dispatch(TelemetryActions.loadAppInsights());
      }
      this.store.dispatch(DocumentActions.getSupportedFileTypes());
      this.store.dispatch(DocumentActions.getFileSizeLimit());
    }
  }
}
